<div class="percentile-container">
    <div class="row">
      <!-- Overall Percentile Card -->
      <div class="col-md-4 mb-4">
        <div class="card percentile-card">
          <div class="card-body text-center">
            <h5 class="card-title">Overall Percentile</h5>
            <div class="percentile-circle" [style.border-color]="getPercentileColor()">
              <div class="percentile-value" [style.color]="getPercentileColor()">
                {{ overallPercentile }}<span class="percentile-suffix">th</span>
              </div>
            </div>
            <p class="percentile-category">{{ percentileCategory }}</p>
            <p class="percentile-note" *ngIf="percentileInfo?.note">
              <mat-icon class="info-icon">info</mat-icon>
              {{ percentileInfo.note }}
            </p>
          </div>
        </div>
      </div>
  
      <!-- Strengths & Weaknesses Card -->
      <div class="col-md-4 mb-4">
        <div class="card">
          <div class="card-header bg-success text-white">
            <h5 class="mb-0">Strengths</h5>
          </div>
          <div class="card-body">
            <div *ngIf="strengths.length > 0; else noStrengths">
              <div class="trait-badge success" *ngFor="let strength of strengths">
                <mat-icon>star</mat-icon>
                {{ formatLabel(strength) }}
              </div>
            </div>
            <ng-template #noStrengths>
              <p class="text-muted text-center">Building data...</p>
            </ng-template>
          </div>
        </div>
      </div>
  
      <div class="col-md-4 mb-4">
        <div class="card">
          <div class="card-header bg-warning text-white">
            <h5 class="mb-0">Areas to Improve</h5>
          </div>
          <div class="card-body">
            <div *ngIf="weaknesses.length > 0; else noWeaknesses">
              <div class="trait-badge warning" *ngFor="let weakness of weaknesses">
                <mat-icon>trending_up</mat-icon>
                {{ formatLabel(weakness) }}
              </div>
            </div>
            <ng-template #noWeaknesses>
              <p class="text-muted text-center">No weaknesses identified</p>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  
    <!-- Percentile Distribution Chart -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">How Well Do I Fit In</h4>
            <p class="card-subtitle">Percentile Distribution Across All Traits</p>
          </div>
          <div class="card-body">
            <div class="chart-wrapper">
              <canvas #barCanvas></canvas>
            </div>
            <div class="percentile-legend mt-3">
              <div class="legend-item">
                <span class="legend-color" style="background-color: rgba(76, 175, 80, 0.7);"></span>
                <span>Top 25% (75-100th percentile)</span>
              </div>
              <div class="legend-item">
                <span class="legend-color" style="background-color: rgba(33, 150, 243, 0.7);"></span>
                <span>Above Average (50-75th percentile)</span>
              </div>
              <div class="legend-item">
                <span class="legend-color" style="background-color: rgba(255, 193, 7, 0.7);"></span>
                <span>Below Average (25-50th percentile)</span>
              </div>
              <div class="legend-item">
                <span class="legend-color" style="background-color: rgba(244, 67, 54, 0.7);"></span>
                <span>Bottom 25% (0-25th percentile)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>